import create from './create'
import update from './update'

const schemas = {
  create,
  update
}

export default schemas
